module.exports = __webpack_public_path__ + "img/chenggong_icon.b93ac646.png";